module.exports = __webpack_public_path__ + "img/hysyd.2dbce261.png";